"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactTextMask = _interopRequireDefault(require("react-text-mask"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var Mask = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(Mask, _Component);

  var _super = _createSuper(Mask);

  function Mask() {
    (0, _classCallCheck2.default)(this, Mask);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(Mask, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          id = _this$props.id,
          inputRef = _this$props.inputRef,
          maskTemplate = _this$props.maskTemplate,
          other = (0, _objectWithoutProperties2.default)(_this$props, ["id", "inputRef", "maskTemplate"]);
      return /*#__PURE__*/_react.default.createElement(_reactTextMask.default, (0, _extends2.default)({
        id: id,
        ref: function ref(_ref) {
          inputRef(_ref ? _ref.inputElement : null);
        },
        mask: maskTemplate
      }, other));
    }
  }]);
  return Mask;
}(_react.Component);

exports.default = Mask;
(0, _defineProperty2.default)(Mask, "propTypes", {
  /**
   * The html id
   */
  id: _propTypes.default.string.isRequired,

  /**
   * Reference to the input component
   */
  inputRef: _propTypes.default.func.isRequired,

  /**
   * Type of mask to render
   */
  maskTemplate: _propTypes.default.oneOfType([_propTypes.default.array, _propTypes.default.func])
});